module.exports = __webpack_public_path__ + "img/trash-bg.08eb03d8.svg";